<form [formGroup]="form" (ngSubmit)="onSubmit()">
  @if (etatPush === undefined || etatPush === "loading") {
    @if (patient) {
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Informations renouvellement</h2>
        <tui-textfield id="nombre-nebuliseur-par-mois">
          <label tuiLabel>Nombre de nébuliseur par mois *</label>
          <input formControlName="nombreNebuliseurParMois" tuiTextfield />
          <tui-error
            formControlName="nombreNebuliseurParMois"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield id="prescription-duree">
          <label tuiLabel>Durée de la prescription (en mois) *</label>
          <input formControlName="prescriptionDuree" tuiTextfield />
          <tui-error
            formControlName="prescriptionDuree"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
      </div>
    } @else {
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Informations patient</h2>
        <tui-textfield>
          <label tuiLabel>Nom *</label>
          <input formControlName="nom" tuiTextfield />
          <tui-error
            formControlName="nom"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Prénom *</label>
          <input formControlName="prenom" tuiTextfield />
          <tui-error
            formControlName="prenom"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <section>
          <label tuiLabel>Sexe *</label>
          <div tuiGroup [collapsed]="true" id="sexe">
            <label tuiBlock>
              Homme
              <input
                formControlName="sexe"
                tuiRadio
                type="radio"
                value="homme"
                [style.margin-left]="'auto'"
              />
            </label>
            <label tuiBlock>
              Femme
              <input
                formControlName="sexe"
                tuiRadio
                type="radio"
                value="femme"
                [style.margin-left]="'auto'"
              />
            </label>
          </div>
          <tui-error
            formControlName="sexe"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <section id="date-de-naissance">
          <tui-input-date formControlName="dateDeNaissance">
            Date de naissance *
          </tui-input-date>
          <tui-error
            formControlName="dateDeNaissance"
            [error]="[] | tuiFieldError | async"
          />
        </section>
        <tui-textfield id="nir">
          <label tuiLabel>NIR *</label>
          <input formControlName="nir" tuiTextfield />
          <tui-error
            formControlName="nir"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Adresse *</label>
          <input formControlName="adresseLigne1" tuiTextfield />
          <tui-error
            formControlName="adresseLigne1"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield>
          <label tuiLabel>Adresse complément</label>
          <input formControlName="adresseLigne2" tuiTextfield />
          <tui-error
            formControlName="adresseLigne2"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <section id="code-postal-et-ville">
          <tui-textfield>
            <label tuiLabel>Code postal *</label>
            <input formControlName="adresseCodePostal" tuiTextfield />
            <tui-error
              formControlName="adresseCodePostal"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
          <tui-textfield>
            <label tuiLabel>Ville *</label>
            <input formControlName="adresseVille" tuiTextfield />
            <tui-error
              formControlName="adresseVille"
              [error]="[] | tuiFieldError | async"
            />
          </tui-textfield>
        </section>
        <tui-textfield id="telephone">
          <label tuiLabel>Numéro de téléphone *</label>
          <input formControlName="telephone" tuiTextfield />
          <tui-error
            formControlName="telephone"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
      </div>
      <div tuiAppearance="floating" tuiCardLarge>
        <h2>Informations prescription</h2>
        <tui-textfield id="nombre-nebuliseur-par-mois">
          <label tuiLabel>Nombre de nébuliseur par mois *</label>
          <input formControlName="nombreNebuliseurParMois" tuiTextfield />
          <tui-error
            formControlName="nombreNebuliseurParMois"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
        <tui-textfield id="prescription-duree">
          <label tuiLabel>Durée de la prescription (en mois) *</label>
          <input formControlName="prescriptionDuree" tuiTextfield />
          <tui-error
            formControlName="prescriptionDuree"
            [error]="[] | tuiFieldError | async"
          />
        </tui-textfield>
      </div>
    }
    <div tuiAppearance="floating" tuiCardLarge>
      <h2>Signature</h2>
      <section id="date-de-prescription">
        <tui-input-date formControlName="dateDePrescription">
          Date de prescription *
        </tui-input-date>
        <tui-error
          formControlName="dateDePrescription"
          [error]="[] | tuiFieldError | async"
        />
      </section>
      <section>
        <div tuiGroup [collapsed]="true">
          @if (patient?.canSign || (!patient && authService.getUser()?.rpps)) {
            <label tuiBlock (click)="selectMe()">
              Signer en mon nom
              <input
                formControlName="aSigner"
                tuiRadio
                type="radio"
                [value]="true"
                [style.margin-left]="'auto'"
              />
            </label>
          }
          <label tuiBlock>
            Préparer au nom de
            <input
              formControlName="aSigner"
              tuiRadio
              type="radio"
              [value]="false"
              [style.margin-left]="'auto'"
            />
          </label>
        </div>
        <tui-error
          formControlName="aSigner"
          [error]="[] | tuiFieldError | async"
        />
      </section>

      @if (this.form.get("aSigner")?.value == false) {
        <section>
          <tui-combo-box formControlName="medecin">
            Préparer au nom de
            <tui-data-list-wrapper
              *tuiDataList
              [items]="userList | tuiFilterByInput: matcherString"
            />
          </tui-combo-box>
          <tui-error
            formControlName="medecin"
            [error]="[] | tuiFieldError | async"
          />
        </section>
      }
      <div id="boutonEnregistrer">
        @if (this.form.get("aSigner")?.value) {
          <button tuiButton type="submit" [disabled]="etatPush === 'loading'">
            Editer et e-signer
          </button>
        } @else {
          <button
            tuiButton
            appearance="outline"
            tuiAppearanceMode="checked"
            type="submit"
            [disabled]="etatPush === 'loading'"
          >
            Editer sans e-signature
          </button>
        }
      </div>
    </div>
  } @else if (etatPush) {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar
        appearance="positive"
        src="@tui.badge-check"
        tuiAnimated
        id="avatar-check"
      />
      <div tuiAnimated>
        Prescription éditée avec succès !
        @if (this.form.get("aSigner")?.value) {
          <br />
          <i
            >(signature électronique en cours, disponible dans quelques
            minutes)</i
          >
        }
      </div>
    </div>
  } @else {
    <div tuiAppearance="floating" tuiCardLarge class="statut-card">
      <tui-avatar appearance="error" src="@tui.badge-alert" tuiAnimated />
      <div tuiAnimated>Une erreur est survenue</div>
      <div id="boutonReessayer">
        <button
          tuiButton
          appearance="outline"
          tuiAppearanceMode="checked"
          (click)="initEtatPush()"
        >
          Réessayer
        </button>
      </div>
    </div>
  }
</form>
